import { render, staticRenderFns } from "./MenuSlot.vue?vue&type=template&id=5c172ed4&"
import script from "./MenuSlot.vue?vue&type=script&lang=js&"
export * from "./MenuSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports